module.exports = __webpack_public_path__ + "media/styles/images/svg/select-teal-db03aa1eef653198395701c8c0592878.svg";